import React from "react";
import PropTypes from "prop-types";
import AsyncAutoComplete from "components/AsyncAutoComplete";
import loadRESubSectorsService from "services/re/loadRESubSectorsService";

function SelectSubSector({
  disabled,
  error,
  onSelect,
  placeholder,
  sectorId,
  readOnly,
  value,
}) {
  return (
    <AsyncAutoComplete
      promiseFn={loadRESubSectorsService}
      onSelect={onSelect}
      idPath="sector_id"
      disabled={!sectorId || disabled}
      error={error}
      intent={!!error ? "danger" : null}
      placeholder={placeholder}
      textPath="sector_publish"
      value={value}
      readOnly={readOnly}
      params={{ sector_id: sectorId }}
    />
  );
}

SelectSubSector.propTypes = {
  disabled: PropTypes.bool,
  error: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  sectorId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  readOnly: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

SelectSubSector.defaultProps = {
  disabled: false,
  error: null,
  placeholder: "Search...",
  sectorId: null,
  readOnly: false,
  value: undefined,
};

export default SelectSubSector;